import React from 'react';
import { PropTypes } from 'prop-types';

import HelpContact from 'components/ModalFaqs/Sections/FaqsWithMarkup/HelpContact';

const Footer = ({ className, customClassName }) => (
  <div className={`${className} ${customClassName}`}>
    <HelpContact />
  </div>
);

Footer.propTypes = {
  className: PropTypes.string,
  customClassName: PropTypes.string,
};

Footer.defaultProps = {
  className: '',
  customClassName: '',
};

export default Footer;
